var map = {
	"./Activity": [
		4926,
		4926
	],
	"./Activity.vue": [
		4926,
		4926
	],
	"./Article": [
		1028,
		1028
	],
	"./Article.vue": [
		1028,
		1028
	],
	"./Audio": [
		80,
		6213,
		6266
	],
	"./Audio.vue": [
		80,
		6213,
		6266
	],
	"./ClickableArea": [
		3276,
		3276
	],
	"./ClickableArea.vue": [
		3276,
		3276
	],
	"./ContentCarousel": [
		4146,
		6213,
		5359
	],
	"./ContentCarousel.vue": [
		4146,
		6213,
		5359
	],
	"./EmbedExercise": [
		3052,
		3052
	],
	"./EmbedExercise.vue": [
		3052,
		3052
	],
	"./H5P": [
		6304,
		6304
	],
	"./H5P.vue": [
		6304,
		6304
	],
	"./ImageElement": [
		9392,
		9392
	],
	"./ImageElement.vue": [
		9392,
		9392
	],
	"./LtiElement": [
		5967,
		5967
	],
	"./LtiElement.vue": [
		5967,
		5967
	],
	"./SectionEndTagElement": [
		3381,
		3381
	],
	"./SectionEndTagElement.vue": [
		3381,
		3381
	],
	"./SectionTagElement": [
		9779,
		9779
	],
	"./SectionTagElement.vue": [
		9779,
		9779
	],
	"./TextBox": [
		4637,
		4637
	],
	"./TextBox.vue": [
		4637,
		4637
	],
	"./TextElement": [
		1756,
		1756
	],
	"./TextElement.vue": [
		1756,
		1756
	],
	"./Video": [
		2510,
		2510
	],
	"./Video.vue": [
		2510,
		2510
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 4880;
module.exports = webpackAsyncContext;